/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CommissionRateServiceVo } from './CommissionRateServiceVo';
import {
    CommissionRateServiceVoFromJSON,
    CommissionRateServiceVoFromJSONTyped,
    CommissionRateServiceVoToJSON,
    CommissionRateServiceVoToJSONTyped,
} from './CommissionRateServiceVo';

/**
 * 
 * @export
 * @interface CodeDetailVo
 */
export interface CodeDetailVo {
    /**
     * 推荐码id
     * @type {number}
     * @memberof CodeDetailVo
     */
    recommendCodeId?: number;
    /**
     * 推荐码
     * @type {string}
     * @memberof CodeDetailVo
     */
    code?: string;
    /**
     * 适用日期
     * @type {string}
     * @memberof CodeDetailVo
     */
    applyDate?: string;
    /**
     * 结算信息（已设置分成的附加服务及比例）
     * @type {Array<CommissionRateServiceVo>}
     * @memberof CodeDetailVo
     */
    rates?: Array<CommissionRateServiceVo>;
}

/**
 * Check if a given object implements the CodeDetailVo interface.
 */
export function instanceOfCodeDetailVo(value: object): value is CodeDetailVo {
    return true;
}

export function CodeDetailVoFromJSON(json: any): CodeDetailVo {
    return CodeDetailVoFromJSONTyped(json, false);
}

export function CodeDetailVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CodeDetailVo {
    if (json == null) {
        return json;
    }
    return {
        
        'recommendCodeId': json['recommendCodeId'] == null ? undefined : json['recommendCodeId'],
        'code': json['code'] == null ? undefined : json['code'],
        'applyDate': json['applyDate'] == null ? undefined : json['applyDate'],
        'rates': json['rates'] == null ? undefined : ((json['rates'] as Array<any>).map(CommissionRateServiceVoFromJSON)),
    };
}

export function CodeDetailVoToJSON(json: any): CodeDetailVo {
    return CodeDetailVoToJSONTyped(json, false);
}

export function CodeDetailVoToJSONTyped(value?: CodeDetailVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'recommendCodeId': value['recommendCodeId'],
        'code': value['code'],
        'applyDate': value['applyDate'],
        'rates': value['rates'] == null ? undefined : ((value['rates'] as Array<any>).map(CommissionRateServiceVoToJSON)),
    };
}

